<template>
  <div>
    <div class="mrB20" />
    <sui-grid
        ref="grid2"
        :columns="gridColumns2"
        :dataset="'dsAppRoleList'"
        :multiselect="false"
        :showDisplayCountControl="false"
    />
    <div class="comm_btn_wrap">
      <sui-button
          v-permission:update="contextPageId"
          type="button"
          class="comm_btn_solid"
          @click="onModClick"
      >
        {{ $t('MSG_BTN_EDIT') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMP_00026_T02', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: '',
    },
    // dataServiceIdentification: {
    //   type: String,
    //   default: '',
    // },
    selectedGridRowData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      roleObjectTypeCode: 'A', // Application
      localdata2: [],
      gridColumns2: [{
        text: this.$t('MSG_TXT_TASK_TYPE'),
        datafield: 'taskName',
        width: 350,
      }, {
        text: this.$t('MSG_TXT_ROLE_ID'),
        datafield: 'roleId',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_ROLE_NAME'),
        datafield: 'roleName',
      }],
    };
  },
  datasets: [{
    id: 'dsAppRoleList',
    type: 'local',
    data: 'localdata2',
    datafields: [
      { name: 'dataset-row-id', type: 'string', map: 'dataset-row-id' },
      { name: 'roleId', type: 'string', map: 'roleId' },
      { name: 'roleName', type: 'string', map: 'roleName' },
      { name: 'taskName', type: 'string', map: 'taskName' },
      { name: 'permissionLevel', type: 'string', map: 'permissionLevel' },
    ],
  }],
  computed: {},
  watch: {
    selectedGridRowData(dataObj) {
      if (utils.isEmpty(dataObj)) {
        this.tabGridClear();
      } else {
        this.roleListLoad();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (!utils.isEmpty(this.selectedGridRowData)) {
        this.roleListLoad();
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    roleListLoad() {
      http.request(this.contextPageId, 'DTS_CMA_00040', {
        query: {
          roleObjectId: this.selectedGridRowData.applicationId,
          roleObjectTypeCode: this.roleObjectTypeCode,
        },
      }).then(res => {
        utils.forEach(res.data, item => {
          const { roleName, taskName } = item.roleInfo;
          utils.assign(item, {
            roleName,
            taskName,
          });
        });
        this.dsAppRoleList.setRawData(res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    tabGridClear() {
      this.dsAppRoleList.setRawData([]);
    },
    onModClick() {
      if (utils.isEmpty(this.selectedGridRowData)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_APPLICATION')));
      } else {
        utils.openLayerPopup('PGE_CMU_00015', this.onPopupClose, {
          pageInitialData: {
            roleObjectId: this.selectedGridRowData.applicationId,
            roleObjectTypeCode: this.roleObjectTypeCode,
          },
          size: 'xlg',
        });
      }
    },
    onPopupClose(saved) {
      if (saved) {
        this.roleListLoad();
      }
    },
  },
};
</script>
<style scoped>
</style>
